import { Visibility, VisibilityOff } from '@interhyp/platform-icons';
import React, { useState } from 'react';
import { Input } from "../input/Input.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const InputPassword = ({
  ...props
}) => {
  const [visible, setVisible] = useState(false);
  const type = visible ? 'text' : 'password';
  const icon = visible ? VisibilityOff : Visibility;
  return /*#__PURE__*/_jsx(Input, {
    ...props,
    onIconClick: () => setVisible(!visible),
    type: type,
    icon: icon
  });
};